import { findSellersByCompany } from '../../_services/user.service';
import { getCompany } from '../../_utils/storage_handler';

export const findAllSellerByCompanyEvent = async () => {
    let res = await findSellersByCompany(getCompany());
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}